export default "__VITE_PUBLIC_ASSET__3fa6653d__"